$('.js-detail-link').on('click', function(e) {
  e.preventDefault();
  var targetStr = $(this).attr('href'),
      $detailContent = $('.js-detail-content[data-id="'+targetStr.substr(1)+'"]');

  $(this).css('display', 'none');
  if ($(this).hasClass('js-detail-link--open')) {
    $detailContent.css('display', 'block');
    $('.js-detail-link--close[href="'+targetStr+'"]').css('display', 'inline-block');
  } else {
    $detailContent.css('display', 'none');
    $('.js-detail-link--open[href="'+targetStr+'"]').css('display', 'inline-block');
  }
})



// WEBPACK FOOTER //
// ./frontend/components/mobile-apps/mobile-apps.js